var ckEditorFix;
(function (ckEditorFix) {
    function init() {
        const $dropdownList = document.querySelectorAll('.ck-dropdown__button');
        if ($dropdownList) {
            $dropdownList.forEach($dropdown => {
                if ($dropdown.getEventListeners('focus'))
                    $dropdown.removeEventListener("focus", $dropdown.getEventListeners('focus')[0].listener);
            });
        }
    }
    window.addEventListener('DOMContentLoaded', init);
})(ckEditorFix || (ckEditorFix = {}));
